import { useClose } from "@headlessui/react"
import { KeyboardEvent, RefObject, useEffect, useRef } from "react"

import { classNames } from "../../../../lib/classNames"
import { TextInput, TextInputProps } from "../../input/text/TextInput"

export interface PopoverTextInputProps extends TextInputProps {
  ref?: RefObject<HTMLInputElement | null>
}

export const PopoverTextInput = (props: PopoverTextInputProps) => {
  const {
    containerClassName,
    className,
    onKeyDown: onKeyDownProp,
    autoFocus = false,
    ref,
    ...otherProps
  } = props

  const close = useClose()
  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape") {
      close()
    }
    onKeyDownProp?.(e)
  }
  const innerRef = useRef<HTMLInputElement>(null)
  const inputRef = ref ?? innerRef

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus({ preventScroll: true })
    }
  }, [autoFocus])

  return (
    <TextInput
      ref={inputRef}
      containerClassName={classNames("p-2", containerClassName)}
      className={classNames(
        "color-subtle bg-elevation-surface-default border-v2-border-strong",
        "focus:bg-v2-background-surface-tonal placeholder:text-v2-foreground-default-weaker",
        "h-8 border px-2 focus:border-transparent",
        className
      )}
      onKeyDown={onKeyDown}
      {...otherProps}
    />
  )
}

export default PopoverTextInput
